import { InjectionToken } from '@angular/core';

export const TESTING_TOAST_CLOSE_ANIMATION_DISABLED =
  new InjectionToken<boolean>('Testing Toast Close Animation Disabled');
